import { render, staticRenderFns } from "./NodeMenu.vue?vue&type=template&id=4e32dfd8&"
import script from "./NodeMenu.vue?vue&type=script&lang=js&"
export * from "./NodeMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e32dfd8')) {
      api.createRecord('4e32dfd8', component.options)
    } else {
      api.reload('4e32dfd8', component.options)
    }
    module.hot.accept("./NodeMenu.vue?vue&type=template&id=4e32dfd8&", function () {
      api.rerender('4e32dfd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/drag/components/NodeMenu.vue"
export default component.exports